import React, { useState , useEffect} from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Drawer, List, ListItem, ListItemText, Box } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';


const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  
  // Add language persistence
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);
  
  const menuItems = React.useMemo(() => [
    { text: t('nav.home'), path: '/' },
    { text: t('nav.services'), path: '/services' },
    { text: t('nav.store'), path: '/store' },
    { text: t('nav.herbtea'), path: '/herbtea' }, // 
    { text: t('nav.telemedicine'), path: '/telemedicine' },
    { text: t('nav.gallery'), path: '/gallery' },
    { text: t('nav.appointment'), path: '/booking' },
    { text: t('nav.contact'), path: '/contact' }
  ], [t]); // Add t as dependency

  // Add language change handler
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <AppBar position="sticky">
      <Toolbar>
        {/* <Typography variant="h6" component={Link} to="/" sx={{ flexGrow: 1, textDecoration: 'none', color: 'inherit' }}>
          {t('nav.title')}
         </Typography> */}
          <Box component={Link} to="/" sx={{ flexGrow: 1, textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
          <img 
            src="/images/newlogo.png" 
            alt={t('nav.title')} 
            style={{ 
              height: '70px', 
              width: '70px',
              borderRadius: '50%', 
              objectFit: 'cover',
              marginRight: '5px' 
            }} 
          />
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
          {menuItems.map((item) => (
            <Button
              key={item.text}
              component={Link}
              to={item.path}
              color="inherit"
            >
              {item.text}
            </Button>
          ))}
          <LanguageSwitcher onLanguageChange={handleLanguageChange} />
        </Box>
        <Box sx={{ display: { md: 'none' } }}>
          <LanguageSwitcher onLanguageChange={handleLanguageChange} />
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={() => setMobileOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      >
        <List sx={{ width: 250, pt: 2 }}>
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.text}
              component={Link}
              to={item.path}
              onClick={() => setMobileOpen(false)}
            >
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;